import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { firstDayOfMonth, toMonthArray, determineErrorState } from './gregorianUtility.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function reducer(state, action) {
  switch (action.type) {
    case 'hideCalendar':
      return _objectSpread(_objectSpread({}, state), {}, {
        activeMonth: '',
        isCalendarVisible: false,
        monthArr: []
      });
    case 'setCalendarVisibility':
      {
        var activeMonth = action.payload === true ? state.selectedRange ? firstDayOfMonth(state.selectedRange.startDate) : firstDayOfMonth(state.selectedDate) : '';
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMonth: activeMonth,
          isCalendarVisible: action.payload,
          monthArr: action.payload === true ? toMonthArray(activeMonth, state.disableDates, state.format) : []
        });
      }
    case 'setDisabledDates':
      {
        var disableDates = action.payload.disableDates;
        return _objectSpread(_objectSpread({}, state), {}, {
          disableDates: disableDates
        });
      }
    case 'setSelectedDate':
      {
        var _action$payload = action.payload,
          date = _action$payload.date,
          format = _action$payload.format;
        var _activeMonth = firstDayOfMonth(date);
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMonth: _activeMonth,
          internalError: determineErrorState({
            dateIn: date,
            disableDates: state.disableDates,
            format: format
          }),
          monthArr: toMonthArray(_activeMonth, state.disableDates),
          selectedDate: date
        });
      }
    case 'setSelectedRange':
      {
        var _action$payload2 = action.payload,
          _date = _action$payload2.date,
          _format = _action$payload2.format;
        var _activeMonth2 = firstDayOfMonth(_date === null || _date === void 0 ? void 0 : _date.startDate);
        var errorState = determineErrorState({
          dateIn: _date === null || _date === void 0 ? void 0 : _date.startDate,
          dateRange: _date,
          disableDates: state.disableDates,
          format: _format
        }) && determineErrorState({
          dateIn: _date === null || _date === void 0 ? void 0 : _date.endDate,
          dateRange: _date,
          disableDates: state.disableDates,
          format: _format
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMonth: _activeMonth2,
          internalError: errorState,
          monthArr: toMonthArray(_activeMonth2, state.disableDates),
          selectedRange: {
            endDate: _date === null || _date === void 0 ? void 0 : _date.endDate,
            startDate: _date === null || _date === void 0 ? void 0 : _date.startDate
          }
        });
      }
    case 'setActiveMonth':
      {
        var _action$payload3 = action.payload,
          _date2 = _action$payload3.date;
          _action$payload3.format;
        var _activeMonth3 = firstDayOfMonth(_date2);
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMonth: _activeMonth3,
          monthArr: toMonthArray(_activeMonth3, state.disableDates)
        });
      }
    default:
      return state;
  }
}
/*
 *  Action creators
 */
var setDisabledDates = function setDisabledDates(disableDates) {
  return {
    payload: {
      disableDates: disableDates
    },
    type: 'setDisabledDates'
  };
};
var setSelectedDate = function setSelectedDate(date, format) {
  return {
    payload: {
      date: date,
      format: format
    },
    type: 'setSelectedDate'
  };
};
var setSelectedRange = function setSelectedRange(date, format) {
  return {
    payload: {
      date: date,
      format: format
    },
    type: 'setSelectedRange'
  };
};
var hideCalendar = function hideCalendar() {
  return {
    type: 'hideCalendar'
  };
};
var setCalendarVisibility = function setCalendarVisibility(isVisible) {
  return {
    payload: isVisible,
    type: 'setCalendarVisibility'
  };
};
var setActiveMonth = function setActiveMonth(date, format) {
  return {
    payload: {
      date: date,
      format: format
    },
    type: 'setActiveMonth'
  };
};

export { hideCalendar, reducer, setActiveMonth, setCalendarVisibility, setDisabledDates, setSelectedDate, setSelectedRange };
